<template>
    <el-table :data="activities" style="width: 100%">
        <el-table-column prop="title" label="标题">
        </el-table-column>
        <el-table-column prop="startDate" label="日期" width="75" :formatter="dateFormatter">
        </el-table-column>
        <el-table-column prop="viewer" label="浏览量" width="75">
        </el-table-column>
    </el-table>
</template>
<script>
import services from '@/services'

export default {
  data () {
    return {
      activities: []
    }
  },
  created: function () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      let that = this
      services.api.activity.latest({}).then(function (response) {
        if (response.data.success) {
          that.activities = response.data.result
        }
      })
    },
    dateFormatter (row, column, cellValue) {
      let cdate = new Date(cellValue)
      let month = cdate.getMonth() + 1
      if (month < 10) { month = '0' + month }
      let day = cdate.getDate()
      if (day < 10) { day = '0' + day }
      return month + '-' + day
    }
  }
}
</script>
<style scoped>
.el-table{
  font-size: inherit;
}
</style>



// WEBPACK FOOTER //
// LatestActivity.vue?3977ecfc